<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">Scan QR</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'"  class="cross-button" [ngClass]="currentHoverEffect" (click)="activeModal?.dismiss()"></app-svg-icon>
</div>

<div class="h-23rem barcode-Scanner-window-css" >
    <div class="my-4">
        <!-- For Single QR Code -->
        <ng-container *ngIf="data?.normalMode == modeOptiontype.NormalMode">
            <app-svg-icon [name]="'normalMode'"></app-svg-icon>
        </ng-container>
        <!-- For Single QR Code -->

        <!-- For Multiple QR Code -->
            <owl-carousel-o *ngIf="data?.inventoryMode == modeOptiontype.InventoryMode" [options]="owlcarousel14Options" (translated)="onSlideChange()">
                <ng-template carouselSlide class="item" [id]="i" *ngFor="let img of slideData; let i = index">
                  <app-svg-icon [name]="img" ></app-svg-icon>
                </ng-template>
            </owl-carousel-o>
        <!-- For Multiple QR Code end -->
    </div>
    <div class="textarea-custom-css" >
        <textarea #barcodeTextarea (ngModelChange)="barcodeData = $event;totalCount()"  [(ngModel)]="barcodeData" class="textarea" name="ShortDesc" id="ShortDesc" cols="100" rows="14">
        </textarea>
    </div>
    <p class="f-14 totalCount-css">Total Count: <span class="fw-bold">{{barcodeCount ? barcodeCount?.length : 0}}</span> </p>
</div>

<div class="modal-footer pt-3 pb-2 mx-2 d-flex align-items-center justify-content-center">
    <app-button class="m-0" [buttonLabel]="'Done'" (buttonOutputEvent)="onClick();"
        [buttonClass]="'blueText_white_bg_button'" [buttonType]="'submit'">
    </app-button>
</div>